/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { ICardFieldProps } from "../cards/CardField"
import { ButtonsPrimitive } from "../../primitive"
import { defaultPrimitive } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
const CardFieldButtons = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props

    useEffect(() => { 
        addCSSClass(
            `landing-card-field-buttons-${ value?.id}`,
            `.landing-card-field-buttons-${ value?.id} {
                width: 100%!important;
            } 
            `
        )
        return () => removeCSSClass(`landing-card-field-buttons-${ value?.id}`)
    }, []) 
    
    const style = { 
        ...field.style, 
        ...value.style 
    }
    style.backgroundColor = undefined
    const primitive = {
        ...defaultPrimitive(),
        ...field,
        ...value,
        data: {
            ...field.data,
            src: value.data,
        },
        style,
        className: (field.className || "") + " " + (value.style || "") + " medallion-padder",
        id: value?.id, 
    }
    return <div 
        className={`landing-card-field landing-card-field-buttons landing-card-field-buttons-${ value?.id} ${value.className || ""}`} 
        style={ style } 
        data-card-field-id={i}
        card-field-section-id={section.id}
    > 
        <ButtonsPrimitive primitive={ primitive } /> 
    </div>
}
export default CardFieldButtons